/**
 * Zugriff auf Bereiche.
 *
 * `useLiveQuery` sorgt dafuer, dass jede Schreiboperation in Dexie die
 * Komponenten von selbst neu rendert - es gibt keinen gespiegelten Store,
 * der aus dem Tritt geraten koennte.
 */
import { useLiveQuery } from 'dexie-react-hooks';
import { useMemo } from 'react';

import { db } from '@/db/schema';
import { NO_AREA_COLOR } from '@/domain/areaColors';
import type { Area, ID } from '@/domain/types';

export function useAreas(includeArchived = false): Area[] {
  const areas = useLiveQuery(() => db.areas.orderBy('order').toArray(), [], [] as Area[]);
  return useMemo(
    () => (includeArchived ? areas : areas.filter((a) => !a.archived)),
    [areas, includeArchived],
  );
}

export function useAreaMap(): Map<ID, Area> {
  const areas = useAreas(true);
  return useMemo(() => new Map(areas.map((a) => [a.id, a])), [areas]);
}

/** Die Farbe eines Bereichs - mit definiertem Wert fuer "ohne Bereich". */
export function useAreaColor(): (areaId: ID | null | undefined) => string {
  const map = useAreaMap();
  return (areaId) => (areaId ? (map.get(areaId)?.color ?? NO_AREA_COLOR) : NO_AREA_COLOR);
}
